import { render, staticRenderFns } from "./bank-info.vue?vue&type=template&id=aaacf462&scoped=true"
import script from "./bank-info.vue?vue&type=script&lang=js"
export * from "./bank-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaacf462",
  null
  
)

export default component.exports